import React, { createContext, useState, useContext, useEffect } from 'react';

export const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      const isMobileView = window.innerWidth <= 1024; // 1024px is typically tablet landscape
      setIsMobile(isMobileView);
      setIsSidebarVisible(!isMobileView); // Hide sidebar by default on mobile
    };

    handleResize(); // Check initial size
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    if (isMobile) {
      setIsSidebarVisible(prev => !prev);
    } else {
      setIsExpanded(prev => !prev);
    }
  };

  return (
    <SidebarContext.Provider value={{ 
      isExpanded, 
      toggleSidebar, 
      isMobile,
      isSidebarVisible 
    }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => useContext(SidebarContext); 